import { Alert, AlertDescription, AlertTitle, cn } from "@qw/ui";
import { useEffect, useState } from "react";

import { EmailLink } from "../components/email-link";
import { useConversation } from "../providers/use-conversation";

export const ConversationCollaboratorAlert = () => {
  const { inboxConversation } = useConversation();
  const [sentinel, setSentinel] = useState<HTMLDivElement | null>(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const conversationInbox = inboxConversation?.inbox;

  useEffect(() => {
    if (!sentinel || typeof IntersectionObserver === "undefined") {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      setIsCollapsed(!entry?.isIntersecting);
    });

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
    };
  }, [sentinel]);

  if (!conversationInbox) {
    return null;
  }

  // Collapsing hides copy with `sr-only` rather than unmounting it. The alert is an assertive live
  // region, so adding and removing text would re-announce it on every scroll past the threshold.
  return (
    <>
      <div className={cn("bg-inherit sticky top-0 z-2", isCollapsed ? "px-3 py-1.5" : "p-3 pb-1.5")}>
        <Alert variant="default" icon="group" className={cn(isCollapsed && "py-2")}>
          <AlertTitle className={cn(isCollapsed && "sr-only")}>You weren't originally on this thread.</AlertTitle>
          <AlertDescription className="items-start">
            <p>
              <span className={cn(isCollapsed && "sr-only")}>You're collaborating on this deal. </span>The thread lives
              in <EmailLink to={conversationInbox.email} />
              's inbox, and replies you send here go out from your own mailbox.
            </p>
          </AlertDescription>
        </Alert>
      </div>
      {/* Both of these must stay direct children of `ColumnContent` — that scroll container is what
          the alert sticks to and what the sentinel is measured against. Sitting below the alert, the
          sentinel leaves the container exactly when sticky positioning takes over, and the alert's
          own height of hysteresis between the two thresholds keeps the collapse from flickering. */}
      <div ref={setSentinel} className="h-px" />
    </>
  );
};
